import {Item, WishItem} from '../classes/Item';
import { STATE, STOCK_LEVEL } from '../classes/Enum';

const singleConditions = ["NM", "LP", "MP", "HP", "DMG", "SEALED"];

export function hasSingleCondition(item) {
  if (!item.conditionQuantities || Object.keys(item.conditionQuantities).length === 0) {
    return item.type === "CARD";
  }
  return Object.values(item.conditionQuantities).some(variantConditions =>
    Object.keys(variantConditions).some(condKey =>
      singleConditions.includes(condKey)
    ));
}

export function hasSlabCondition(item) {
  if (!item?.conditionQuantities) return false;

  return Object.values(item.conditionQuantities).some(variantConditions =>
    Object.entries(variantConditions || {}).some(
      ([cond, data]) =>
        !singleConditions.includes(cond) && (data?.quantity ?? 0) > 0
    )
  );
}

export function getVisibleProducts(products, debouncedQuery, state) {
  return products.filter(item => {
    if (debouncedQuery.length == 0) {
      if (state === STATE.SINGLE && item.type ==='CARD') {
        return hasSingleCondition(item);
      }
      if (state === STATE.SLAB) {
        return hasSlabCondition(item);
      }
      if (state === STATE.OVERVIEW) {
        return true;
      }
      return item.type === state;
    }
    else {
      if (state === STATE.SLAB) {
        return hasSlabCondition(item) && ((item.name.includes(debouncedQuery.toUpperCase())
    || (item.setName || "").includes(debouncedQuery.toUpperCase()))
    || (item.pokemonType === debouncedQuery.toUpperCase()))
      }
      return (item.type === state && ((item.name.includes(debouncedQuery.toUpperCase())
    || (item.setName || "").includes(debouncedQuery.toUpperCase()))
    || (item.pokemonType === debouncedQuery.toUpperCase())))
    }});
}

export function sortProductsByQuantity(products) {
  return [...products].sort((a, b) => (b.quantity ?? 0) - (a.quantity ?? 0));
}

export function sortProductsByPrice(products, direction = "asc") {
  const priceMultiplier = direction === "desc" ? -1 : 1;
  return [...products].sort((a, b) => {
    const aInStock = (a.quantity ?? 0) > 0;
    const bInStock = (b.quantity ?? 0) > 0;
    if (aInStock !== bInStock) {
      return aInStock ? -1 : 1;
    }
    const priceDiff = getListingPriceCents(a) - getListingPriceCents(b);
    if (priceDiff !== 0) {
      return priceDiff * priceMultiplier;
    }
    return (b.quantity ?? 0) - (a.quantity ?? 0);
  });
}

export const PRODUCT_SORT_OPTIONS = [
  { value: "price_asc", label: "Price: Low to High" },
  { value: "price_desc", label: "Price: High to Low" },
  { value: "recent_updated", label: "Recently Updated" },
  { value: "set", label: "Set (A-Z)" },
  { value: "series", label: "Series (A-Z)" },
];


export function removePageItems(items, page) {
    let res = items;
    return items.filter(item => item.page !== page);
  }

export function addPageItems(products, items, page) {
    let addProducts = products.filter(product => product.page === page);
    return [...items, addProducts];
}

export function serializeItem(product, page) {
  return new Item(
        product.id,
        product.product_name,
        Number(product.price).toFixed(2),
        product.quantity,
        product.type,
        product.series_name,
        product.set_name,
        product.subtext,
        product.desc,
        product.condition_quantities,
        product.pokemon_type,
        product.set_id,
        page,
        product.can_buy,
        product.last_updated
      )
};

export function serializeWishItem(obj) {
  return new WishItem(obj);
}

export function getDisplayPrice(priceCents) {
  return (priceCents / 100).toFixed(2);
}

export function getListingPriceCents(item) {
  if (item?.conditionQuantities) {
    let minPrice = null;
    for (const variant of Object.values(item.conditionQuantities)) {
      for (const data of Object.values(variant || {})) {
        if (data?.quantity > 0 && data?.price != null) {
          const price = Number(data.price);
          if (price > 0 && (minPrice === null || price < minPrice)) {
            minPrice = price;
          }
        }
      }
    }
    if (minPrice !== null) {
      return minPrice;
    }
  }
  return Number(item?.price ?? 0);
}

export function getListingPriceText(item) {
  if (!item || item.quantity <= 0) {
    return "";
  }
  const cents = getListingPriceCents(item);
  if (cents <= 0) {
    return "";
  }
  return getDisplayPrice(cents);
}

export function getItemPriceCents(selectedItem, condition, variant) {
  if (selectedItem?.type === "CARD" && condition != null && variant != null) {
    const conditionData = selectedItem.conditionQuantities?.[variant ?? ""]?.[condition ?? ""];
    if (conditionData?.price != null) {
      return Number(conditionData.price);
    }
  }
  return Number(selectedItem?.price ?? 0);
}

export function canBuy(selectedItem, condition, variant) {
  if (!selectedItem?.canBuy || selectedItem.quantity <= 0) {
    return false;
  }
  return getItemPriceCents(selectedItem, condition, variant) > 0;
}

export function getStockLevel(quantity, type) {

  if (quantity <= 0) return "NONE";

  if (quantity <= STOCK_LEVEL[type]) return "LOW";

   return "IN";
}